import { lazy } from 'react';

export const EditDeveloperPage = lazy(() =>
  import('./ui/EditDeveloperPage').then((module) => ({
    default: module.EditDeveloperPage,
  }))
);
